/**
 * mc-product-page.js — Manifesto
 *
 * Interatividade leve da PDP (sections/main-product-manifesto.liquid):
 *   1. Galeria — clicar numa thumbnail troca a imagem principal.
 *   2. Total dinâmico — atualiza "Adicionar — R$X" conforme a quantidade
 *      (X = preço unitário × qty), espelhando o ProductDetailPage.tsx.
 *   3. "N unidades no carrinho" — atualiza ao mudar o carrinho (pub/sub Dawn).
 *
 * O add-to-cart em si é do <product-form> do Dawn (product-form.js), que abre
 * a gaveta lateral Manifesto. Este script só cuida da apresentação.
 */

(function () {
  'use strict';

  var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  function initGallery(root) {
    var main = root.querySelector('[data-mc-pdp-main]');
    var thumbs = root.querySelectorAll('[data-mc-pdp-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) {
          main.removeAttribute('srcset');
          main.src = full;
        }
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  function initQtyTotal(root) {
    var qtyInput = root.querySelector('[data-mc-pdp-qty]');
    var label = root.querySelector('[data-mc-pdp-add-label]');
    var priceEl = root.querySelector('[data-mc-pdp-unit-price]');
    if (!qtyInput || !label || !priceEl) return;

    var unitCents = parseInt(priceEl.getAttribute('data-mc-pdp-unit-price'), 10) || 0;
    // Só altera o label quando o produto está disponível (label = "Esgotado" some).
    if (/esgotado/i.test(label.textContent)) return;

    function render() {
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var total = (unitCents * qty) / 100;
      label.textContent = 'Adicionar — ' + BRL.format(total);
    }

    qtyInput.addEventListener('change', render);
    qtyInput.addEventListener('input', render);
    render();
  }

  function initInCart(root) {
    var box = root.querySelector('[data-mc-pdp-in-cart]');
    if (!box) return;
    var variantId = box.getAttribute('data-variant-id');
    var countEl = box.querySelector('[data-mc-pdp-in-cart-count]');
    var suffixEl = box.querySelector('[data-mc-pdp-in-cart-suffix]');

    function apply(count) {
      if (countEl) countEl.textContent = String(count);
      if (suffixEl) suffixEl.textContent = count === 1 ? 'unidade' : 'unidades';
      box.classList.toggle('is-hidden', count <= 0);
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var count = 0;
          cart.items.forEach(function (it) {
            if (String(it.variant_id) === String(variantId)) count += it.quantity;
          });
          apply(count);
        })
        .catch(function () {});
    }

    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', refresh);
    }
  }

  function init() {
    var root = document.querySelector('[data-section-type="main-product-manifesto"]');
    if (!root) return;
    initGallery(root);
    initQtyTotal(root);
    initInCart(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
